// Client-side timezone helper. The app's timezone is configurable by the
// admin (Settings → General → Timezone) and arrives via the dashboard
// settings payload. We cache it on window so every render site can read it
// without prop-drilling.

const DEFAULT_TZ = 'Asia/Kolkata';

export function setAppTimezone(tz) {
  if (typeof window === 'undefined') return;
  window.__APP_TZ = (typeof tz === 'string' && tz.trim()) ? tz.trim() : DEFAULT_TZ;
}

export function getAppTimezone() {
  if (typeof window !== 'undefined' && window.__APP_TZ) return window.__APP_TZ;
  return DEFAULT_TZ;
}

// Format a Date/timestamp as "HH:MM" in the app timezone.
export function fmtTime(input) {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d)) return '—';
  return new Intl.DateTimeFormat('en-IN', {
    timeZone: getAppTimezone(),
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).format(d);
}

// Format as "DD/MM/YYYY" in the app timezone.
export function fmtDate(input) {
  if (!input) return '—';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d)) return '—';
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: getAppTimezone(),
    day: '2-digit', month: '2-digit', year: 'numeric',
  }).format(d);
}

// "DD/MM/YYYY HH:MM"
export function fmtDateTime(input) {
  if (!input) return '—';
  return `${fmtDate(input)} ${fmtTime(input)}`;
}
